module.exports = __webpack_public_path__ + "static/img/reference_page top img_desktop.a182cc64.jpg";